import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import * as Permissions from 'permissions';
import * as Actions from 'actions';
import { ImpactMapList, EditMarkerModal } from 'components';
import { distance } from 'utils';

class MarkerDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      deleting : false,
    }

    this.handleClickDeleteMarker = this.handleClickDeleteMarker.bind(this);
    this.handleClickKnockOnDoor = this.handleClickKnockOnDoor.bind(this);
  }
  handleClickKnockOnDoor(marker) {
    const markerLocation = {
      lat: marker.location.coordinates[1],
      lng: marker.location.coordinates[0]
    };
    const currentLocation = this.props.current_location;
    const dist = currentLocation ? distance(markerLocation, currentLocation) : undefined;
    const isVerified = dist ? dist < 152.4 : false;

    this.props.updateMarker({
      ...marker,
      verified: isVerified,
      ...(dist ? ({ distance: dist }) : ({})),
      door_knock_number: marker.door_knock_number ? marker.door_knock_number + 1 : 1
    });
  }
  handleClickDeleteMarker(marker) {
    this.setState({deleting: false});
    this.props.deleteMarker(marker);
  }

  render() {
    if(!this.props.hasPermission(Permissions.VIEW_CANVASSING_MARKERS)) {
      return <noscript />
    }

    const marker = this.props.markers.find(({_id}) => (_id == this.props.marker));
    if(!this.props.marker || !marker) {
      return <noscript />
    }
    const marker_types = this.props.marker_types || [];
    return (
      <div className='animated bounceInDown'>
        <h3 className='text-primary'><i className='fa fa-map-marker'></i> {marker.title}</h3>
        <ul className='list-unstyled text-muted'>
          <li><i className='fa fa-info'></i> {(marker_types.find(type => type.key == marker.type) || {}).name || marker.type}</li>
          {marker.edited_by? <li><i className='fa fa-user'></i> Last Edited by {marker.edited_by.name ? marker.edited_by.name.first : marker.edited_by.username}</li> : null}
          {marker.created_by? <li><i className='fa fa-user'></i> Created by {marker.created_by.name ? marker.created_by.name.first : marker.created_by.username}</li> : null}
          <li><i className='fa fa-calendar'></i> Created on {moment(marker.updated_timestamp).format('MMM DD, YYYY h:m:s')}</li>
          {marker.verified ? (
            <li className="text-success"><i className="fa fa-certificate"></i> Verified {`( <= 500 feet)`}</li>
          ) : (
            <li className="text-warning"><i className="fa fa-exclamation"></i> Not Verified {'( > 500 feet)'}</li>
          )}
          {marker.door_knock_number ? (
            <li>{marker.door_knock_number} Door Knocks</li>
          ) : null}
        </ul>

        {this.state.deleting ?
          <div className='btn-group pull-right'>
            <div
              onClick={e => this.handleClickDeleteMarker(marker)}
              className='animated fadeInLeft btn btn-danger'
              >
              <i className='fa fa-trash' /> Are you sure?
            </div>

            <div
              onClick={e => this.setState({deleting: false})}
              className='animated fadeInRight btn btn-default'
              >
              <i className='fa fa-close' />
            </div>
          </div> :
          <div
            onClick={e => this.setState({deleting: true})}
            className='btn pull-right btn-danger'
            >
            <i className='fa fa-trash' />
          </div>}
          <div
            className='btn btn-warning pull-right'
            onClick={() => this.props.toggleShowEditMarkerModal(true)}
            >
            <i className='fa fa-pencil' />
          </div>
        <hr />
        <div onClick={e => this.handleClickKnockOnDoor(marker)} className="btn btn-default btn-block btn-sm">
          <i className="fa fa-home"></i> Knock on Door
        </div>

        <ImpactMapList coords={{lat: marker.location.coordinates[1], lng: marker.location.coordinates[0]}} />

        <EditMarkerModal marker={marker} />
      </div>
    )
  }
}

const m = ({canvassing : {marker_types, markers}}) => ({markers, marker_types});

export default connect(m, Actions)(MarkerDetails);



// WEBPACK FOOTER //
// ./src/browser/components/clients/canvassing/marker-details.js